import React, { Component } from 'react';
import AnyModel from "../../models/anymodel";
import  PanelLayout  from "../layout/panel-layout";
import { Link } from 'react-router-dom';
import Select from 'react-select';
import SimpleReactValidator from 'simple-react-validator';


import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import moment from 'moment-jalaali';

class ChangePassword extends React.Component {
    
    
    constructor(props) {
        super(props);
        this.state = { 
           model:new AnyModel(this.refs),
           
        };
      
        this.handleTextChange = this.handleTextChange.bind(this);
        this.getData = this.getData.bind(this);
        this.handleClick= this.handleClick.bind(this);
        this.refreshModel = this.refreshModel.bind(this);


        


        SimpleReactValidator.addLocale('fa', {
            required: 'الزامی',
            integer: 'الزامی'
            
          });

        this.validator = new SimpleReactValidator({
            locale: 'fa'
          
          });

    }

     
   

    
    handleTextChange(value) {
  
        const {model}=this.state;
       
        this.setState({
            model:model
        })

        this.refreshModel();
    }

   
    componentWillReceiveProps(newProps)
    {
       
        
    }

    refreshModel () {
        let model = new AnyModel(this.refs);  
        this.setState({

            model:model

        });

        console.log('MODEL',model);

        
    }
    getData() {
        let model = new AnyModel(this.refs);
        return model;
    }
   
    handleClick = (e) => {
        if (this.validator.allValid()) {
            
            this.props.submitHandler(e);

        } else {
            this.validator.showMessages();
           
            this.forceUpdate();
        }
    };

    render() { 
        //const {model} = this.props;
        const {recieverList,model}= this.state;
        const {loading,error} = this.props;
    

 
        return ( 

        <PanelLayout title={"تغییر کلمه عبور"}>

           
            <div className="panel-body custom">

            <div className="panel panel-default">
               
                <div className="toolbox">

                    <button type="button" disabled ={loading } className="btn btn-default btn-sm" onClick={this.handleClick} ><i className="fa fa-save"></i>   ذخیره
                    
                     { loading &&
                         <i className="fa fa-spinner fa-spin"></i>
                     }

                     </button>


                
                </div>
            </div>
                
            <div class="panel panel-default">
                <div class="panel-heading">تغییر رمز عبور</div>
                <div class="panel-body">

                    <form autoComplete="off" ref={c => { this.form = c }}>


                        <div className="row">
                            <div className="col-md-12">
                               
                                <div className="form-group">
                                    <label className="col-md-12">
                                        رمز عبور جدید
                                    </label>
                                    <div className="col-md-6">

                                        <input  name="NewPassword" ref="NewPassword" className="form-control" value={model && model.NewPassword} type="password" onChange={this.refreshModel}></input>
                       
                                    </div>
                                    <div className="col-md-6"></div>
                                    
                                    {this.validator.message('NewPassword', model.NewPassword, 'required|string')}
                                   
                                </div>
                                <div className="form-group">
                                    <label className="col-md-12">
                                       تکرار رمز عبور جدید
                                    </label>
                                    <div className="col-md-6">

                                        <input  name="NewPasswordConfirm" ref="NewPasswordConfirm" className="form-control" value={model && model.NewPasswordConfirm} type="password" onChange={this.refreshModel}></input>
                       
                                    </div>
                                    <div className="col-md-6"></div>
                                    
                                    {this.validator.message('NewPasswordConfirm', model.NewPasswordConfirm, 'required|string')}
                                   
                                </div>
                                
                               
                                

                            </div>
                        </div>
                       
                        
                        
                       
                    </form>
                
                
                </div>
            </div>
               
            </div>
        </PanelLayout>





        );
    }
}

 
export default ChangePassword;